function setJwt(jwt: string) {
  localStorage.setItem('jwt', jwt);
}

function getJwt(): string | null {
  return localStorage.getItem('jwt');
}

function removeJwt(): void {
  localStorage.removeItem('jwt');
}

export { setJwt, getJwt, removeJwt };
